import React, { FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './EmailIcon.module.css';

const EmailIcon: FC = () => {
  const { iconsPrimaryNone } = useTheme();

  return (
    <svg
      className={styles.container}
      style={{
        fill: iconsPrimaryNone?.color,
        ...iconsPrimaryNone,
      }}
      viewBox="0 0 54 54"
      role="presentation"
    >
      <g fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M36.5 7.57c-.43-.25-.9-.38-1.38-.38H3.62c-.49 0-.96.13-1.38.38L19.37 20.4z"
        />
        <path
          fillRule="nonzero"
          d="M37.9 18.54V9.97v-.3L19.37 23.52.83 9.7V31.2a2.8 2.8 0 002.79 2.78h20.6c0-7.86 5.87-14.49 13.68-15.44z"
        />
        <path d="M39.8 20.17a13.82 13.82 0 100 27.65 13.82 13.82 0 000-27.65zm0 2a11.8 11.8 0 014.52 22.74 11.81 11.81 0 11-4.52-22.74z" />
        <path d="M35.17 38.67a1.27 1.27 0 111.28-1.26c-.02.69-.6 1.24-1.28 1.23z" />
        <path d="M42.6 36.92h-5.18a2.2 2.2 0 00-4.36 0H31.6V36l.62.06v-7.68h9.69s.68.22.68.67zM45.35 38.82a1.27 1.27 0 111.32-1.3 1.27 1.27 0 01-1.32 1.26z" />
        <path d="M48.75 37.2h-1.13a2.22 2.22 0 00-3.51-1.77v-4.7h2.95l1.66 2.74z" />
      </g>
    </svg>
  );
};

export default EmailIcon;
